import { useContext, useEffect, useRef, useState } from "react";
import { RulesPermissionUserContext } from "../contexts/RulesPermissionUser";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { mountingColumns } from "../headerColumns";
import { removeSpecials } from "../functionsGlobal";
import { useDebouncedFilterWithRef } from "./useDebouncedFilter";
import { DarkModeContext } from "../contexts/darkMode";
import { entrar, logout } from "../services/auth";
import { useLoginContext } from "../contexts/login";

export const useCadEmpresas = (props) => {
    const [CadEmpresa, setCadEmpresa] = useState([]);
    const {login} = useContext(RulesPermissionUserContext);
    const { updateSystemColor } = useContext(DarkModeContext);
    const {setSessionExpiration, validationImportNFCE, verifyTipeFreight, setReloadSidebar} = useLoginContext()
    const history = useHistory();
    const inputRef = useRef(null);


    useEffect(() => {
        setCadEmpresa(mountingColumns('cadEmpresas',props.resultado.cnpj))
    }, [])


    const HandleCliqueHref = async (item, index) => {
        try {
            if(item?.liberado === 'N') return props.isVisibleMessage('Sistema Sem Liberação!', 'warning');
            entrar('CNPJ', item.valor); 
            entrar('NOMEEMPRESA',item.nome_empresa); 
            entrar('SISTESHOP', item.sisteshop === 'S' ?  true : false);
            updateSystemColor(item.sisteshop === 'S' ?  true : false)

            entrar('ADM', props.resultado.usuario[index].administrador);   
            entrar('COMPANIES', JSON.stringify(props.resultado));   
            login(props.resultado.usuario[index].pemissao_acesso);
            setSessionExpiration()
            logout('SIDEBAR')
            logout('TYPE_FREIGHT')
            await validationImportNFCE()
            await verifyTipeFreight()
           if(item?.televendas === 'S'){
                entrar('ID_VENDEDOR', props.resultado.usuario[index].id_vendedor);   
                entrar('SIDEBAR', JSON.stringify({televendas:item.televendas}));
                const [_, second] = window.location.pathname.split('/')
                props.onClose()
                if(((window.location.pathname !== '/Televendas' && window.location.pathname !== '/Televendas/Finalizadas') && second !== 'dashboard')) history.push('/Televendas')
                if(window.location.pathname ==='/Televendas/Finalizadas') history.push('/Televendas/Finalizadas')
                if(window.location.pathname ==='/Televendas') history.push('/Televendas')
                setReloadSidebar(false)
            }
            else{
                setReloadSidebar(true)
                props.onClose()
                history.push('/dashboard');
            }
            
            
        } catch (error) {
            console.log(error)
        }
    }

    const filterFn = (data, filterValue) => {
        const cleaned = removeSpecials(filterValue.toLowerCase());
        return data.filter((item) =>
        removeSpecials(item.nome_empresa.toLowerCase()).includes(cleaned)
        );
    };

    const { filteredData, isFiltering } = useDebouncedFilterWithRef(
        CadEmpresa[0]?.rows || [],
        inputRef,
        filterFn,
        (filtered) => (filtered.length ? mountingColumns("cadEmpresas", filtered) : []),
        300 // debounce em ms
    );

    return {
        CadEmpresa, setCadEmpresa, login, updateSystemColor, inputRef, history,
        HandleCliqueHref, filteredData, isFiltering

    }
}